<template>
  <v-container fluid grid-list-md>
    <v-layout row wrap>
      <v-flex xs12 lg12>
        <v-data-table
          :headers="headers"
          :items="inactive"
          :rows-per-page-items="[100, 200]"
        >
          <template v-slot:items="props">
            <td>{{ props.item.trigram }}</td>
            <td>{{ props.item.email }}</td>
            <td>{{ props.item.lastName }}</td>
            <td>{{ props.item.firstName }}</td>
            <td>
              {{ props.item.lastLease.progress.sentToAL | date }} (<a
                :href="`/project/${props.item.lastLease._id}`" target="_blank"
                >{{ props.item.lastLease._id }}</a
              >)
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  mounted() {
    this.refreshInactive();
  },
  data() {
    return {
      headers: [
        { text: "Trigramme", value: "trigram" },
        { text: "E-mail", value: "email" },
        { text: "Nom", value: "lastName" },
        { text: "Prénom", value: "firstName" },
        { text: "Dernier dossier", value: "lastLease.progress.sentToAL" }
      ]
    };
  },
  computed: {
    ...mapState("admin", ["inactive"])
  },
  methods: {
    ...mapActions("admin", ["fetchInactiveTrigrams"]),

    refreshInactive() {
      return this.fetchInactiveTrigrams();
    }
  }
};
</script>

<style scoped></style>
